import { render, staticRenderFns } from "./max.vue?vue&type=template&id=54ca44be&scoped=true"
import script from "./max.vue?vue&type=script&lang=js"
export * from "./max.vue?vue&type=script&lang=js"
import style0 from "./max.vue?vue&type=style&index=0&id=54ca44be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ca44be",
  null
  
)

export default component.exports